import { Spinner } from 'components/ui/Spinner';

/** Centered loading indicator for page / section level fetches. */
export function LoadingState({ label = 'Loading…', className }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-16 text-slate-500 ${className || ''}`}>
      <Spinner size="lg" className="text-brand-600" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export default LoadingState;
